import { useLocalePath } from '#imports'
import { placeOrder as placeOrderApi } from '~/apis/spot'
import { usePanelStore } from '~/store/spot/panel'
import { useSpotStore } from '~/store/spot'
import { makeUUID } from '~/utils/tools'

export function usePlaceOrder() {
  const spot = useSpotStore()
  const panel = usePanelStore()
  const loading = ref(false)

  async function placeOrder(o = {}) {
    if (loading.value)
      return

    loading.value = true
    const { symbol = spot.code, side = panel.side, ordType = panel.orderType, ordPrice = panel.getPrice, ordQty = panel.qty, ordAmt = panel.amount, ...rest } = o

    const isBuy = side === 'BUY'
    const isMarket = ordType === 'MARKET'

    const payload = Object.assign({}, rest, {
      symbol,
      timestamp: Date.now(),
      // accountId: '1234',
      clOrdId: makeUUID(),
      side,
      ordType,
    })

    if (!isMarket) {
      payload.ordPrice = ordPrice
    }

    if (isBuy && isMarket) {
      payload.ordAmt = ordAmt
    }
    else {
      payload.ordQty = ordQty
    }

    const res = await placeOrderApi(payload)
    loading.value = false

    return res
  }

  return { placeOrder }
}

export function useUrlReplaceSymbol() {
  const spot = useSpotStore()
  const localePath = useLocalePath()

  return function urlReplaceSymbol(code = spot.defaultCode) {
    spot.code = code
    if (import.meta.client) {
      window.history.replaceState(null, '', localePath(`/spot/${code}${location.search}`))
    }
  }
}
